import React from "react";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, FieldArray, Field, change } from "redux-form";
import {ff, form, Icon, utils} from "@mc/mc-legacy";
import { Loader } from "@mc/mc-legacy";
import * as approverActions from "../../actions/approverActions";
import { Button } from "reactstrap";
import { Col, Row } from "@mc/ui-v3";
import "./FlowConfigurationForm.scss";
const { Form, FormBody, FormActions } = form;

const validate = (formData) => {
    const errors = {} as any;
    if (!formData.name) {
        errors.name = "Povinný parametr";
    }
    if (!formData.code) {
        errors.code = "Povinný parametr";
    }
    if (formData.steps && formData.steps.length > 1) {
        formData.steps.forEach((step, indexStep) => {
            if (step.approvers) {
                step.approvers.forEach((approver, indexApp) => {
                    if (!approver.pracovnikId) {
                        if (!errors.steps) {
                            errors.steps = [];
                        }
                        if (!errors.steps[indexStep]) {
                            errors.steps[indexStep] = {
                                approvers: []
                            }
                        }
                        errors.steps[indexStep].approvers[indexApp] = {
                            pracovnikId: "Je třeba vyplnit schvalovatele"
                        }
                    }
                })
            }
        });
    }
    console.warn(errors);
    return errors;
};

class FlowConfigurationForm extends React.Component {
    static formName = "FlowConfigurationForm";

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fetchData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    props.dispatch(approverActions.fetchApproversIfNeeded());
  };

    renderApprovers = ({fields, step, stepFields, stepIndex}) => {
        const { submitting, ApproverList } = this.props;
        const schvalovatelItems = [];
        ApproverList.rows &&
        ApproverList.rows.forEach((item) => {
            schvalovatelItems.push({
                id: item.pracovnik.id,
                name: `${item.pracovnik.uplneJmeno} ${item.pracovnik.organizacniJednotka ? `(${item.pracovnik.organizacniJednotka.kod})` : ""}`,
                title: item.pracovnik.organizacniJednotka.nazev,
            });
        });

        return (
            <div className="step-approvers">
                {fields.map((field, index) => {
                    const approver = step.approvers[index];
                    const removeStep = fields.length == 1;
                    return <Row noGutters className="approver" key={index}>
                        <Col>
                            <ff.Autocomplete
                                name={field + ".pracovnikId"}
                                items={schvalovatelItems}
                                useIdAsValue={true}
                                label={false}
                                renderItemContent={(item, name) => {
                                    if (name && name.length > 0) {
                                        return (
                                            <span title={item.title ? item.title : ""} className="item-text">
                                           {name}
                                         </span>
                                        );
                                    } else {
                                        return <span className="item-text">&nbsp;</span>;
                                    }
                                }}
                                disabled={submitting}
                            />
                        </Col>
                        {(<Col className="d-flex justify-content-center" xs="auto">
                            <Button
                                disabled={submitting}
                                className="d-flex align-self-center mt-1 btn-transparent"
                                title="Odebrat schvalovatele"
                                onClick={() => {
                                    fields.remove(index);
                                    removeStep && stepFields.remove(stepIndex)
                                }}>
                                <Icon size="lg" icon={"trash-o"} />
                            </Button>
                        </Col>)}
                        {index + 1 == fields.length && (<Col className="d-flex justify-content-center mt-2" xs="auto">
                            <Button
                                disabled={submitting}
                                className="d-flex align-self-center btn-transparent"
                                title="Přidat schvalovatele"
                                onClick={() => {fields.push({pracovnikId: null, flowId: null})}}>
                                <Icon size="lg" icon={"plus-square-o"} />
                            </Button>
                        </Col>)}
                    </Row>
                })}
            </div>
        );
    };

    renderSteps = ({fields}) => {
        const {submitting, steps} = this.props;
        return (
            <div>
                {fields.map((field, index) => {
                    if (steps) {
                        const step = steps[index];
                        return <Row noGutters className="step mb-2" key={index}>
                            <Col>
                                <ff.String label="" placeholder={'Popis'} name={field + ".name"}
                                           disabled={submitting}/>
                                <ff.Checkbox
                                    label={false}
                                    checkboxLabel="Schvalují všichni"
                                    name={field + ".everyone"}
                                    title="Schvalovatel je pouze ten, který si potvrdí převzetí. V opačném případně musí provést schválení všichni zmínění schvalovatelé."
                                    disabled={submitting}
                                />
                                <FieldArray name={field + ".approvers"} step={step} stepFields={fields}
                                            stepIndex={index} component={this.renderApprovers}/>
                            </Col>
                        </Row>
                    } else {
                        return <Loader key={index}/>;
                    }
                })}
                <Button
                    disabled={submitting}
                    className="btn-transparent p-0 mt-2"
                    title="Přidat krok"
                    onClick={() => {
                        fields.push({
                            name: "Krok č. " + (steps.length + 1),
                            everyone: false,
                            approvers: [{pracovnikId: null, flowId: null}]
                        })
                    }}>
                    <Icon size="lg" icon={"plus-square-o"} className={"mr-2"}/>Přidat krok
                </Button>
            </div>
        );
    };

    render() {
        const {onClose, submitting, handleSubmit } = this.props;
    return (
      <Form className="flow-configuration-form" onSubmit={handleSubmit}>
        <FormBody>
          <ff.String required label="Název konfigurace" name="name" disabled={submitting} />
          <ff.String required label="Kód konfigurace" name="code" disabled={submitting} />
          <FieldArray name="steps" component={this.renderSteps}/>
        </FormBody>
        <FormActions onClose={onClose} storeButton cancelButton disabled={submitting} />
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector(FlowConfigurationForm.formName);
  return {
    ApproverList: utils.storeFromArea(state, approverActions.APPROVER_LIST),
    steps: selector(state, "steps"),
  };
}

const reduxFormObj = reduxForm({
  form: FlowConfigurationForm.formName,
  validate: validate,
})(FlowConfigurationForm);
export default connect(mapStateToProps)(reduxFormObj);
